export default {
    message: "The items listed below are out of stock and have been removed from your cart. Please make different selections.",
    buttons: {
        ok: "Ok"
    }
}